module.exports = __webpack_public_path__ + "assets/img/1671589449114_.pic_hd.6a0e270a.jpg";